/*eslint-disable*/
import { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import UseAxios from '../../../Api/http/http';
import { getPendingOnboardingReport } from '../../../Api/request/misReports';
import { format } from 'date-fns';
import { getPendingOnboardingReportExcel } from '../../../Api/request/reports';
import { defaultDateRanges } from './defaultDate';


export function useResourcePendingOnboarding() {
  const [pendingOnboarding, setPendingOnboarding] = useState(0);
  const [rows, setRows] = useState([]);
  const initialDateRange =
  defaultDateRanges.find((range) => range.label === 'This Week') || {};

const [dateRange, setDateRange] = useState({
  startDate: initialDateRange.startDate,
  endDate: initialDateRange.endDate,
  label: initialDateRange.label,
});
  useEffect(() => {
    getPendingOnboardingData(
      initialDateRange.startDate,
      initialDateRange.endDate
    );
  }, []);

  const getPendingOnboardingData = async (startDate, endDate, dealType) => {
    try {
      const formattedStartDate = startDate
        ? format(startDate, 'yyyy-MM-dd')
        : '';
      const formattedEndDate = endDate ? format(endDate, 'yyyy-MM-dd') : '';

      const response = await UseAxios(
        getPendingOnboardingReport(formattedStartDate, formattedEndDate, dealType)
      );

      const rawData = response.data;

      const values = rawData.resourcePendingDetails.map((row, index) => ({
        ...row,
        id: row.uuid || row.positionId || index,
      }));

      setPendingOnboarding(rawData.totalPendingOnboarding);
      setRows(values);
      setDateRange({ startDate, endDate });
    } catch (error) {
      console.error('Error fetching Lost/Dropped positions:', error);
    }
  };

  const getPendingOnboardingDataDownload = async (startDate, endDate) => {
    try {
      await getPendingOnboardingReportExcel(startDate || null, endDate || null);
      return { success: true };
    } catch (error) {
      return { success: false };
    }
  };

  return {
    getPendingOnboardingData,
    rows,
    pendingOnboarding,
    getPendingOnboardingDataDownload,
    dateRange,
    setDateRange
  };
}
